import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import all translation files
import en from "../locales/en/common.json";
import es from "../locales/es/common.json";
import ptBR from "../locales/pt-BR/common.json";
import it from "../locales/it/common.json";
import id from "../locales/id/common.json";
import ar from "../locales/ar/common.json";
import fr from "../locales/fr/common.json";
import de from "../locales/de/common.json";
import hi from "../locales/hi/common.json";
import he from "../locales/he/common.json";
import zhCN from "../locales/zh-CN/common.json";

const resources = {
  en: { common: en },
  es: { common: es },
  "pt-BR": { common: ptBR },
  it: { common: it },
  id: { common: id },
  ar: { common: ar },
  fr: { common: fr },
  de: { common: de },
  hi: { common: hi },
  he: { common: he },
  "zh-CN": { common: zhCN },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },

    // Use static resources instead of HTTP backend
    resources,

    // Default namespace
    defaultNS: "common",

    // Supported languages list
    supportedLngs: [
      "en",
      "es",
      "pt-BR",
      "it",
      "id",
      "ar",
      "fr",
      "de",
      "hi",
      "he",
      "zh-CN",
    ],

    // Enable browser locale detection - prioritize user choice over browser
    detection: {
      order:
        typeof window !== "undefined"
          ? ["localStorage", "navigator", "htmlTag"]
          : [],
      caches: typeof window !== "undefined" ? ["localStorage"] : [],
      lookupLocalStorage: "i18nextLng",
    },

    // Don't set a default language - let detection handle it
    // lng: "en",

    ns: ["common"],
  });

export default i18n;
